import React, { Component } from "react"
import "./StreamMember.scss"
import {
  CheckValue,
  env,
  getMediaPermission,
} from "../../../services/CommonFunction"
import { staticVar } from "../../../services/Constants"
import { WebRTCAdaptor } from "../../../js/webrtc_adaptor"
import { ErrorUI } from "../../../components/UI/Modals/Modals"
import { selectIcon, SVG } from "../../../components/UI/selector"
import { messageService } from "../../../services/subscriberService"
import axios from "../../../axios"
import ApiURL from "../../../services/ApiURL"

class StreamMember extends Component {
  state = {
    constraints: { video: { width: 1280, height: 720, deviceId: "" } },
    isCameraEnabled: false,
    isStreamStarted: false,
    videoId: "memberVideo",
    webRTCAdaptor: null,
  }

  get getStreamData() {
    return this.state
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.actionPerform !== this.props.actionPerform) {
      this.checkStorage()
    }
  }
  componentDidMount() {
    console.log("enter-StreamMember")
    // if(localStorage.getItem('firstTime')) {
    //     localStorage.removeItem('firstTime');
    //     ErrorUI('We are using your web camera and mic',null,{submitText:'Ok',close:() => {
    //         this.checkStorage();
    //     }});
    // } else {
    // }
    if (this.props.actionPerform) {
      this.checkStorage()
    }
  }

  checkStorage = () => {
    if (localStorage.getItem("isCameraEnabled")) {
      // this.setState({ isCameraEnabled: true });
      // this.streamStartedStopped(false);
      // this.startStream(this.props.userActivityData, this.streamStartedStopped)
      setTimeout(() => {
        this.checkPermission(
          this.props.userActivityData,
          this.streamStartedStopped
        )
      }, 0)
    }
  }
  componentWillUnmount() {
    if (this.state.isCameraEnabled) {
      this.state.webRTCAdaptor.stop(
        this.props.userActivityData.user_activity_session_id
      )
    }
    this.closeCamera()
  }

  get getMemberVideoData() {
    return { ...this.state }
  }

  startStream = (props, streamStarted) => {
    // const userId = props.activity_ids+'_'+props.user_id;
    // console.log(this.state.isCameraEnabled);
    // console.log('userActivityData',userActivityData);
    axios
      .post(ApiURL._beforeStartMyVideo, {
        user_activity_session_id: props.user_activity_session_id,
      })
      .then(async (res) => {
        this.checkPermission(props, streamStarted)
      })
      .catch((err) => {
        // ErrorUI(err.response.data);
        this.checkPermission(props, streamStarted)
      })
  }

  checkPermission = (props, streamStarted) => {
    getMediaPermission(
      this.state.constraints,
      this.state.videoId,
      0,
      false
    ).then((res) => {
      if (res.status) {
        if (localStorage.getItem("firstTime")) {
          localStorage.removeItem("firstTime")
          ErrorUI(staticVar.textMsg, null, {
            close: () => {
              this.startLocalStream(props, streamStarted, res)
            },
          })
        } else {
          // console.log('enter-else');
          this.startLocalStream(props, streamStarted, res)
        }
      } else {
        console.log("error")
        ErrorUI(
          "Kindly allow access to your camera and microphone in your settings and try again."
        )
      }
    })
  }

  startLocalStream = (props, streamStarted, res) => {
    messageService.background = true
    messageService.sendMessage(true)
    const userId = props.user_activity_session_id
    console.log("props", props)
    const { isStreamStarted } = this.state
    // return null;
    var pc_config = null

    var sdpConstraints = {
      OfferToReceiveAudio: true,
      OfferToReceiveVideo: true,
    }

    var mediaConstraints = {
      video: true,
      audio: false,
    }
    // var WebRTCAdaptor = require(adapter);
    let webRTCAdaptor = new WebRTCAdaptor({
      websocket_url: env("AntMediaUrl"),
      mediaConstraints: mediaConstraints,
      peerconnection_config: pc_config,
      sdp_constraints: sdpConstraints,
      localVideoId: this.state.videoId,
      isPlayMode: true,
      debug: false,
      callback: function (info) {
        if (info === "initialized") {
          console.log("initialized")
          // webRTCAdaptor.joinRoom(props.activity_id,userId);
          let timeoutTime = 0
          // if(CheckValue(localStorage.getItem('isCameraEnabled'))) {
          //     timeoutTime = 2000;
          // }
          setTimeout(() => {
            webRTCAdaptor.publish(userId)
            // streamStarted(true);
          }, timeoutTime)
          //called by JavaScript SDK when WebSocket is connected.
        } else if (info === "joinedTheRoom") {
          console.log("joinedTheRoom")
          //called when this client is joined the room
          //obj contains streamId field which this client can use to publish to the room.
          //obj contains also the active streams in the room so that you can play them directly.
          //In order to get the streams in the room periodically call `getRoominfo`
        } else if (info === "newStreamAvailable") {
          console.log("newStreamAvailable")
          //called when client is ready to play WebRTC stream.
        } else if (info === "publish_started") {
          console.log("publish_started")
          streamStarted(true)
          //called when stream publishing is started for this client
        } else if (info === "publish_finished") {
          console.log("publish_finished", webRTCAdaptor)
          streamStarted(false)
          //called when stream publishing has finished for this client
        } else if (info === "leavedFromRoom") {
          console.log("leavedFromRoom")
          //called when this client is leaved from the room
        } else if (info === "closed") {
          console.log("closed")
          //called when websocket connection is closed
        } else if (info === "play_finished") {
          console.log("play_finished", webRTCAdaptor)
          //called when a stream has finished playing
        } else if (info === "streamInformation") {
          console.log("streamInformation")
          //called when a stream information is received from the server.
          //This is the response of `getStreamInfo` method
        } else if (info === "roomInformation") {
          console.log("roomInformation")
          //Called by response of `getRoomInfo` when a room information is received from the server.
          //It contains the array of the streams in the room.
        } else if (info === "data_channel_opened") {
          console.log("data_channel_opened")
          //called when data channel is opened
        } else if (info === "data_channel_closed") {
          console.log("data_channel_closed")
          streamStarted(null)
          // called when data channel is closed
        } else if (info === "data_received") {
          console.log("data_received")
          //called when data is received through data channel
        }
      },
      callbackError: function (error) {
        //some of the possible errors, NotFoundError, SecurityError,PermissionDeniedError
        console.log("error callback: " + error)
        streamStarted(false)
        messageService.background = false
        messageService.sendMessage(false)
        // if (typeof error === 'string') {
        //     ErrorUI("error callback: " + error);
        // }
      },
    })
    this.setState({
      webRTCAdaptor: webRTCAdaptor,
    })
  }

  streamStartedStopped = (status) => {
    if (!CheckValue(status)) {
      console.log(this.state.isStreamStarted)
      if (!this.state.isStreamStarted && this.state.webRTCAdaptor) {
        this.state.webRTCAdaptor.stop(
          this.props.userActivityData.user_activity_session_id
        )
        messageService.background = true
        messageService.sendMessage(true)

        setTimeout(() => {
          messageService.background = false
          messageService.sendMessage(false)
          this.startStream(
            this.props.userActivityData,
            this.streamStartedStopped
          )
        }, 500)
      }
    } else {
      this.setState({ isStreamStarted: status })
      const obj = {
        ...this.props.userActivityData,
      }
      if (this.props.pushSocket) {
        this.props.socket.emit(
          status ? "publish_stream_started" : "publish_stream_stopped",
          obj,
          (data) => {
            console.log("publish_stream_started", data)
            ////console.log("Web Off");
          }
        )
      }
      messageService.background = false
      messageService.sendMessage(false)
      if (!status) {
        this.setState({
          isCameraEnabled: status,
          webRTCAdaptor: null,
        })
        this.closeCamera()
        localStorage.removeItem("isCameraEnabled")
      } else {
        this.setState({
          isCameraEnabled: true,
        })
        localStorage.setItem("isCameraEnabled", "true")
      }
    }
  }

  closeCamera = () => {
    const videoElem = document.getElementById(this.state.videoId)
    if (CheckValue(videoElem)) {
      const stream = videoElem.srcObject
      if (CheckValue(stream)) {
        stream.getAudioTracks().forEach(function (track) {
          track.stop()
        })
        stream.getVideoTracks().forEach(function (track) {
          //in case... :)
          track.stop()
        })
        videoElem.srcObject = null
      }
    }
  }

  stopStream = () => {
    if (CheckValue(this.state.webRTCAdaptor)) {
      console.log("enter-stopStream")
      this.state.webRTCAdaptor.stop(
        this.props.userActivityData.user_activity_session_id
      )
    }
  }

  onOffCamera = (status) => {
    if (status) {
      this.state.webRTCAdaptor.turnOnLocalCamera()
    } else {
      this.state.webRTCAdaptor.turnOffLocalCamera()
    }
    this.setState({
      // webRTCAdaptor: null,
      isCameraEnabled: status,
    })
  }

  startStopStream = () => {
    if (this.state.isCameraEnabled) {
      this.stopStream()
    } else {
      this.startStream(this.props.userActivityData, this.streamStartedStopped)
    }
  }

  render() {
    const { videoId, isCameraEnabled } = this.state
    return (
      <React.Fragment>
        {/* <video className={`member_video${isCameraEnabled ? ' show' : ''}`} id={videoId} autoPlay muted></video> */}
        <video className={`member_video1`} id={videoId} autoPlay muted></video>
        {/* {isCameraEnabled ?
                    <button className='stopMyVideo' onClick={() => this.stopStream()}>
                        <img src={selectIcon('videoIcon')} alt="video_icon" /> 
                        <SVG src={selectIcon('video')} />
                    </button> :
                    <button className='startMyVideo' onClick={() => this.startStream(this.props.userActivityData, this.streamStartedStopped)}>START MY VIDEO</button>
                } */}
      </React.Fragment>
    )
  }
}

export default StreamMember
